import moment from 'moment'
import {isRegExp} from "bootstrap-vue/esm/utils/inspect";

//日付の範囲バリデーション
const custom_date_between = {

  // ルールを書くときに使う引数。
  params: ['min', 'max'],

  // バリデーションロジック(戻り値がtrue=通過,false=拒否
  validate(field, between = {min: null, max: null}) {
    if (!(between.min && between.max)) return true
    return moment(field).isBetween(between.min, between.max);
  },
}

const password = {
  // 8文字以上32文字以下
  // 半角英数字のみ
  // 数字、小文字、大文字、記号を最低一文字
  validate(field) {
    const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!-/:-@[-`{-~])[!-~]{8,32}$/
    return pattern.test(field)
  },
}

const correlation = {
  params: [{
    name: 'str',
    isTarget: true
  }],

  validate(field, { str }) {
    if (!str) return false
    return field == str
  },
  message(field, { str }) {
    return `${field}と${str}が一致しません`
  },
}

const decimal = {
  // 小数点1桁まで
  validate(field) {
    const pattern = /^[0-9]*(\.[0-9]?)?$/
    return pattern.test(field)
  },
}

export {custom_date_between,password,correlation,decimal}
